import axios from 'axios';

export const getBlogCategories = async () => {
    try {
        const wpCategories = process.env.REACT_APP_WP_CATEGORIES;
        const url = `${process.env.REACT_APP_WP_API_URL_V2}/categories?include=${wpCategories}`;
        const response = await axios.get(
            url,
            {
                params: {
                    _fields: [
                        'id',
                        'count',
                        'parent',
                        'description',
                        'link',
                        'name',
                        'slug'
                    ]
                }
            }
        );
        const categories = response.data;

        return Array.isArray(categories) ? categories : [];
    } catch (error) {
        console.error('Erreur lors de la récupération des catégories :', error);
        return [];
    }
};
